import axios from "axios";
import { IP_ADDRESS } from "../config";
const { handleAxiosError } = require("./error.handler.service");
export const aliasService = async (alias) => {
  try {
    const resp = await axios.get(`${IP_ADDRESS}/company/authorization/alias`, {
      params: { alias },
    });
    return resp.data;
  } catch (err) {
    handleAxiosError(err);
  }
};
